export default __webpack_public_path__ + "/dist/images/6126739.035bd0eb3e69e3d736a2ece648934eca.png";